"use strict";

module.exports.log = {
  error: function error() {
    if (console && console.error) {
      var _console;

      (_console = console).error.apply(_console, arguments);
    }
  }
};
//# sourceMappingURL=log.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-bi-logger-client/dist/utils/log.js
// module id = 234
// module chunks = 0